module.exports = __webpack_public_path__ + "img/right_single_title.92228cc9.png";